module.exports = "## Raised Button\nThis [button](https://www.google.com/design/spec/components/buttons.html#buttons-flat-raised-buttons)\nis used to add dimension to mostly flat layouts and emphasizes important functions on your page.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/RaisedButton/README.md
 ** module id = 1036
 ** module chunks = 0
 **/